import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enMain from './en/main.json';
import ruMain from './ru/main.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    ns: ['main'],
    defaultNS: 'main',
    resources: {
      en: { main: enMain },
      ru: { main: ruMain },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
